import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=0b84086f&scoped=true&"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js&"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=0b84086f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b84086f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b84086f')) {
      api.createRecord('0b84086f', component.options)
    } else {
      api.reload('0b84086f', component.options)
    }
    module.hot.accept("./TermsAndCondition.vue?vue&type=template&id=0b84086f&scoped=true&", function () {
      api.rerender('0b84086f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/TermsAndCondition.vue"
export default component.exports